export default __webpack_public_path__ + "cf7b2d1e3b37a9cf3c488acc735e1c65.svg";